import React from 'react';

import { redirectToOrderProcessingPage } from 'common/utilities/utils';

import {
  getAddEditFavouriteModal,
  getReorderModal,
  getViewReceiptModal,
} from '../sharedTemplates/orderHistoryModalTemplate';

import {
  getCompletedOrdersPanelJSX,
  getCurrentOrdersPanelJSX,
  getEmptyMessagePlaceHolderJSX,
  GetHaveQuestionSectionJSX,
  getLoadMorePanelJSX,
  getOrderHistoryHeaderJSX,
} from '../sharedTemplates/orderHistoryViewTemplates';
import { getOrderSummaryDirectionMapModal } from 'organisms/orderSummaryViews/utils/orderSummaryModelViewUtils';

const orderHistoryView = props => {
  const { orderHistoryDetails, updateSetOrderHistoryDetails } = props;
  const { orderDetails } = orderHistoryDetails;

  const updateOrderDetails = details => {
    updateSetOrderHistoryDetails({ orderDetails: { ...orderDetails, ...details } });
  };
  return (
    <div className='order-history col-12 au'>
      {getOrderHistoryHeaderJSX(props)}
      {getEmptyMessagePlaceHolderJSX(props)}
      {getCurrentOrdersPanelJSX({ ...props, redirectTo: redirectToOrderProcessingPage })}
      {getCompletedOrdersPanelJSX({ ...props, redirectTo: redirectToOrderProcessingPage })}
      {getLoadMorePanelJSX(props)}
      {GetHaveQuestionSectionJSX(props)}
      {getViewReceiptModal(props)}
      {orderDetails.isOpenOrderSummaryDirectionMap &&
        getOrderSummaryDirectionMapModal({ orderDetails, updateSetOrderDetails: updateOrderDetails })}
      {getAddEditFavouriteModal(props)}
      {getReorderModal(props)}
    </div>
  );
};
export default React.memo(orderHistoryView);
